module.exports = __webpack_public_path__ + "static/media/row-unselected.2b36da53.svg";